import { render, staticRenderFns } from "./popup-notifier.vue?vue&type=template&id=2d06510f&scoped=true&"
import script from "./popup-notifier.vue?vue&type=script&lang=js&"
export * from "./popup-notifier.vue?vue&type=script&lang=js&"
import style0 from "./popup-notifier.vue?vue&type=style&index=0&id=2d06510f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06510f",
  null
  
)

export default component.exports